import React, { lazy, Suspense } from "react";

// Use the pre-built UMD bundle to avoid CRA's d3-array ESM resolution bug.
const Plot = lazy(async () => {
  const [Plotly, factoryMod] = await Promise.all([
    import("plotly.js-dist-min"),
    import("react-plotly.js/factory"),
  ]);
  const createPlotlyComponent = factoryMod.default || factoryMod;
  return { default: createPlotlyComponent(Plotly.default || Plotly) };
});

export default function PlotlyChart(props) {
  return (
    <Suspense fallback={
      <div className="h-full w-full flex items-center justify-center text-xs text-[#4B5563]">
        Loading chart…
      </div>
    }>
      <Plot
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
        config={{ displaylogo: false, responsive: true, ...(props.config || {}) }}
        {...props}
      />
    </Suspense>
  );
}
